import React, { Component } from 'react';
import { DataOperation } from '../../data/DataOperation';
import { EUIComboBox } from '../EUI/EUIComboBox';

export class ComboBoxCompteCommercialisant extends Component {

    static defaultProps = {
        idOperation: 0,
        idSociete: null,
        label: "Compte",
        placeholder: "Compte",
    };

    render = () => {

        const { idOperation, idSociete } = this.props;

        let fetchMethod = null;
        if (!!idOperation) fetchMethod = () => DataOperation._chargementComptesCommercialisants(idOperation, idSociete);

        return <EUIComboBox
            {...this.props}
            fetchMethod={fetchMethod}
            idValeurParDefaut="0"
            itemKey={item => item.loginCompte}
            itemText={item => `${item.prenom} ${item.nom}`.trim()}
            stamp={[idOperation, idSociete]}
        />;

    };

};